<template lang="pug">
  div.stu-header.bg-white
    div.W
      //- router-link.logo.fl(:to='{name: "stuIndex"}')
        img(src='@/assets/image/common/logo.png' alt='logo')
      img(src='/static/images/logo_stu.png' v-if='!t2s' ref='logo' @click='handleHome' style='width:auto;height:70px;cursor: point;')
      img(src='/static/images/logo_jiaoshiyanxun.png' v-else ref='logo' @click='handleHome' style='width:auto;height:70px;cursor: point;')
      slot
      //- div.stu-header-linkArea.text-ct(v-if='!t2s')
      //-   //- a.fr(@click='changeLang') {{$t('header.lang')}}
      //-   a.fr.f16(v-if="!checkIsZhaoyang" href='/static/page/download.html' target='_blank') {{ $t('header.app') }}
      //-   a.fr.f16(href='/static/page/about.html' target='_blank') {{ $t('header.about') }}
    div.stu-header-tip.browser-tip(v-if="!isssproctor && platform === 'windows' && browser.name !== 'Chrome'")
      p {{$t('header.tip_windows')}}
      a(href='http://17ks.chivoxapp.com/guide/360Browse.exe')
        i.icon-360
        | {{$t('header.browser360')}}
      a(href='http://17ks.chivoxapp.com/guide/QQBrowser.exe')
        i.icon-qq
        | {{$t('header.browserqq')}}
      b(@click="platform = ''")
    div.stu-header-tip.browser-tip(v-if="!isssproctor && platform === 'mac' && browser.name !== 'Safari'")
      p {{$t('header.tip_mac')}}
      b(@click="platform = ''")
</template>

<script>
export default {
  name: 'Header',
  data() {
    const isssproctor = localStorage.getItem('isssproctor')
    return {
      checkIsZhaoyang: window.ConfigNew.checkIsZhaoyang, // 朝阳去隐藏二维码
      t2s: localStorage.getItem('t2s'),
      logo: window.ConfigNew.logoUrl('logo.stu.png'),
      platform: this.$util.osCheck(),
      browser: this.$util.browserCheck(),
      isssproctor
    }
  },
  methods: {
    handleHome() {
      if (!this.isssproctor) {
        this.$router.push({ name: 'stuIndex' })
      }
    },
    changeLang() {
      if (this.$i18n.locale === 'zh') {
        this.$i18n.locale = 'tw'
      } else {
        this.$i18n.locale = 'zh'
      }
    },
    logout() {
      this.$emit('handleLogout')
    }
  }
}
</script>

<style>
@import './../../../static/styles/common/km-header.css';
.stu-header .W > label {
  color: #999;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Stu/header.vue